var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "judgmentForm",
      attrs: {
        inline: true,
        model: _vm.academicDirectorJudgment,
        "label-width": "150px"
      }
    },
    [
      _vm.isReappraisal && this.workingApplication.overdue
        ? _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c("el-alert", {
                staticStyle: {
                  border: "1px solid",
                  "background-color": "#fdf6ec"
                },
                attrs: {
                  closable: false,
                  type: "warning",
                  title: _vm.OVERDUE_MESSAGE,
                  "show-icon": ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal
        ? _c(
            "el-form-item",
            { attrs: { label: "Κατηγορία αίτησης" } },
            [
              _c("el-switch", {
                attrs: {
                  disabled: "",
                  "active-text": "Νομικό ζήτημα",
                  "inactive-text": "Ακαδημαϊκό ζήτημα"
                },
                model: {
                  value: _vm.workingApplication.legalIssue,
                  callback: function($$v) {
                    _vm.$set(_vm.workingApplication, "legalIssue", $$v)
                  },
                  expression: "workingApplication.legalIssue"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("internalComments"),
      _vm._v(" "),
      _c("proposals"),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Εσωτερικό Σχόλιο" } },
        [
          _c("el-input", {
            staticClass: "biggest",
            attrs: {
              type: "textarea",
              autosize: { minRows: 4, maxRows: 10 },
              placeholder: "Εισάγετε κείμενο για τον Πρόεδρο"
            },
            on: { change: _vm.modifycomment },
            model: {
              value: _vm.academicDirectorJudgment.internalComment,
              callback: function($$v) {
                _vm.$set(_vm.academicDirectorJudgment, "internalComment", $$v)
              },
              expression: "academicDirectorJudgment.internalComment"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.fromPresident
        ? _c(
            "el-form-item",
            { attrs: { label: "Αντισταθμιστικά μέτρα" } },
            [
              _c("el-input", {
                staticClass: "biggest",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "Ορισμός αντισταθμιστικών μέτρων (υποχρεωτικός)"
                },
                model: {
                  value: _vm.academicDirectorJudgment.proposal,
                  callback: function($$v) {
                    _vm.$set(_vm.academicDirectorJudgment, "proposal", $$v)
                  },
                  expression: "academicDirectorJudgment.proposal"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal
        ? _c(
            "el-form-item",
            { attrs: { label: "Πρακτικό Δ.Σ." } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.uploading,
                      expression: "uploading"
                    }
                  ],
                  ref: "uploadBoardMinutesOnReappRef",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".pdf",
                    "file-list": _vm.boardMinutesOnReappAttachments,
                    "http-request": _vm.addAttachment,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.handleBeforeRemove,
                    "on-preview": _vm.viewPdf,
                    limit: 1,
                    action: "",
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary",
                        disabled:
                          this.boardMinutesOnReappAttachments.length >= 1
                      },
                      slot: "trigger"
                    },
                    [_vm._v("Ανέβασμα")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Πρακτικού Δ.Σ. για την εισήγηση της Ειδ. Επιτρ. Επανεξέτασης (pdf έως 12MB)"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          !_vm.isReappraisal
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.tempSave()
                    }
                  }
                },
                [_vm._v("Αποθήκευση")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: !_vm.isValidForm
              },
              on: {
                click: function($event) {
                  _vm.finalSave()
                }
              }
            },
            [_vm._v("Οριστική Υποβολή")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c6a563e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6a563e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/AcademicDirectorJudgement.vue
// module id = null
// module chunks = 